import { emptySplitApi } from '@/redux/base-api';
import { StylistNameParams, StylistNameResponse } from './types';

const apiWithTag = emptySplitApi.enhanceEndpoints({ addTagTypes: ['StylistNames'] });

const extendedApi = apiWithTag.injectEndpoints({
	endpoints: (build) => ({
		getStylistNames: build.query<StylistNameResponse[], StylistNameParams>({
			query: (params) => ({
				url: '/stylists',
				method: 'GET',
				params
			}),
			transformResponse: (response: { stylists: StylistNameResponse[] }) => response.stylists,
			providesTags: () => [{ type: 'StylistNames', id: 'LIST' }]
		})
	})
});

export const { useGetStylistNamesQuery } = extendedApi;
